import script from "./SearchSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSelect.vue?vue&type=script&setup=true&lang=ts"

import "./SearchSelect.vue?vue&type=style&index=0&id=e0fa05a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0fa05a0"]])

export default __exports__